import { Input } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { getExpectNumber } from '../../../../../common'
import { SearchDrawerComponent } from '../../../../../components'
import { translate } from '../../../../../languages'
import { RootState } from '../../../../../stores'
import { setDebtFilter } from '../../../../../stores/actions'

const StyledRow = styled.div`
  margin-bottom: 10px;
  display: flex;
`

export const SearchDebtDrawerComponent: React.FC = () => {
  const dispatch = useDispatch()
  const { language } = useSelector((state: RootState) => state.language)
  const { debtFilter } = useSelector((state: RootState) => state.debt)
  const [filter, setFilter] = React.useState(debtFilter)

  const body = (
    <>
      <StyledRow>
        <Input
          placeholder={translate('debt.card.id', language)}
          addonBefore={translate('debt.card.id', language)}
          value={filter.cardId}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              cardId: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('debt.customer', language)}
          addonBefore={translate('debt.customer', language)}
          value={filter.customerName}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              customerName: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('debt.station', language)}
          addonBefore={translate('debt.station', language)}
          value={filter.stationName}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              stationName: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow style={{ flexWrap: 'wrap' }}>
        <Input
          placeholder={translate('debt.accountsPayable.to', language)}
          addonBefore={translate('debt.accountsPayable.to', language)}
          value={filter.totalAccountsPayableFrom}
          type="number"
          style={{ marginBottom: '10px' }}
          allowClear
          min={1}
          onChange={(e: any) =>
            setFilter({
              ...filter,
              totalAccountsPayableFrom: e.target.value,
            })
          }
        />
        <Input
          placeholder={translate('debt.accountsPayable.to', language)}
          addonBefore={translate('debt.accountsPayable.to', language)}
          value={filter.totalAccountsPayableTo}
          type="number"
          allowClear
          min={1}
          onChange={(e: any) =>
            setFilter({
              ...filter,
              totalAccountsPayableTo: e.target.value,
            })
          }
        />
      </StyledRow>
    </>
  )

  return (
    <SearchDrawerComponent
      body={body}
      onSearch={() =>
        dispatch(
          setDebtFilter({
            ...filter,
            pageIndex: 1,
            totalAccountsPayableFrom: getExpectNumber(
              true,
              filter.totalAccountsPayableFrom,
              filter.totalAccountsPayableTo
            ),
            totalAccountsPayableTo: getExpectNumber(
              false,
              filter.totalAccountsPayableFrom,
              filter.totalAccountsPayableTo
            ),
          })
        )
      }
    />
  )
}
